import { useCallback, useEffect, useState } from "react";
import { accountService } from "../../Api/Services/accountService";
import { ForgotPasswordStep } from "../../Enums/ForgotPasswordStep";
import ForgotPasswordModal from "../ForgotPasswordModal/ForgotPasswordModal";
import ForgotPasswordInfoModal from "../ForgotPasswordInfoModal/ForgotPasswordInfoModal";

type ForgotPasswordFlowProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ForgotPasswordFlow = ({ isOpen, onClose }: ForgotPasswordFlowProps) => {
  const [step, setStep] = useState<ForgotPasswordStep | null>(null);
  const [maskedPhone, setMaskedPhone] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleCloseAll = useCallback(() => {
    setStep(null);
    setMaskedPhone(null);
    setErrorMessage(null);
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      setStep(ForgotPasswordStep.Email);
    } else {
      handleCloseAll();
    }
  }, [isOpen, handleCloseAll]);

  const handleSubmitEmail = async (email: string) => {
    try {
      const result = await accountService.forgotPassword({ email });
      
      if (!result) {
        setErrorMessage("O email informado não possui cadastro no site!");
        setTimeout(() => setErrorMessage(null), 5000);
        return;
      }

      if (!result.maskedPhone) {
        setErrorMessage("Não foi possível enviar pelo WhatsApp. Verifique se sua conta tem um celular cadastrado ou fale com a loja.");
        setTimeout(() => setErrorMessage(null), 8000);
        return;
      }

      setErrorMessage(null);
      setMaskedPhone(result.maskedPhone);
      setStep(ForgotPasswordStep.Info);
    } catch (err) {
      setErrorMessage("Ocorreu um erro, tente novamente mais tarde!");
      setTimeout(() => setErrorMessage(null), 5000);
    }
  };

  return (
    <div>
      <ForgotPasswordModal 
        isOpen={step === ForgotPasswordStep.Email}
        onClose={handleCloseAll}
        onSubmit={handleSubmitEmail}
        errorMessage={errorMessage}
      />

      <ForgotPasswordInfoModal
        isOpen={step === ForgotPasswordStep.Info}
        onClose={handleCloseAll}
        phone={maskedPhone ?? ""}
      />
    </div>
  );
};

export default ForgotPasswordFlow;
